import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class DebugInventoryActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Accounting/Inventory/InventoryBrowser")
	}

	render() {
		return (
			<Activity 
				name="DebugInventory"
				RenderedComponent={this.RenderedComponent}
				context="DebugInventory"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(DebugInventoryActivity)
